import { registerEnumType } from 'type-graphql'

export enum AiCreditTransactionTypeEnum {
  Debit = 'Debit',
  Grant = 'Grant',
  Adjustment = 'Adjustment',
  Purchase = 'Purchase',
}

registerEnumType(AiCreditTransactionTypeEnum, {
  name: 'AiCreditTransactionTypeEnum',
  description:
    'Ledger entry type for an AiCreditTransaction — Debit consumes balance, Grant adds it (admin, free), Purchase adds it (bought by the owner), Adjustment is a manual correction.',
})
